import * as React from "react";
import { getDirectionsUrl } from "../../helpers/location";
import ServiceLocationSlots from "./services/ServiceLocationSlots";

export default class Location extends React.Component {
    constructor(props) {
        super(props);
    }
    

    redirectToMap(item) {
        if (item.locationStreet1) {
            const toAddress = item.locationStreet2 ?
                item.locationStreet1 + ', ' + item.locationStreet2 + ', ' + item.locationCity + ', ' + item.locationState + ' ' + item.locationZip :
                item.locationStreet1 + ', ' + item.locationCity + ', ' + item.locationState + ' ' + item.locationZip
                ;
            var addressUrl = getDirectionsUrl(null, toAddress);
            if (typeof window !== 'undefined' && addressUrl) {
                window.open(addressUrl, "_blank");
            }
        }
    }

    //We get the update later on we will uncomment
   /* goToLocation(item) {
        if (typeof window !== "undefined" && item.locationUrl) {
            window.open(item.locationUrl, "_blank");
        }
    }*/

    render() {
        const mammogram2DVisitType = `visitTypeId=${window.serverData.data.mammographyVisitTypeId}`;
        const mammogram3DVisitType = `visitTypeId=${window.serverData.data.mammography3DVisitTypeId}`;
        const mammogram2D3DVisitType = `visitTypeId=${window.serverData.data.mammographyVisitTypeId},${window.serverData.data.mammography3DVisitTypeId}`;
        const mammogram3D2DVisitType = `visitTypeId=${window.serverData.data.mammography3DVisitTypeId},${window.serverData.data.mammographyVisitTypeId}`;
        const { appliedRulesLoc, scheduleCampaignReferrer} = this.props;
        const showLocationSlots = window.serverData.data.enableFindCareNewSearchTerms && appliedRulesLoc && (appliedRulesLoc.indexOf(mammogram2DVisitType) > -1 || appliedRulesLoc.indexOf(mammogram3DVisitType) > -1 || appliedRulesLoc.indexOf(mammogram2D3DVisitType) > -1 || appliedRulesLoc.indexOf(mammogram3D2DVisitType) > -1) ;        
        const loc = this.props.locationData;       
        const locPhoto = loc.photoUrl ? loc.photoUrl : '/images/location-pic.png';
      //  const locationClass = loc.locationUrl ? "finger" : "";
        return (
            <div className="col-12 find-care-list-item find-care-list-item--location">
                <div className="row find-care-item-row">
                    <div className="col-12 item-profile-container">
                        <div className="row">
                            <div className="col-12 item-details-container">
                                <div className="item-avatar-container">
                                    <div className="item-img-container" style={{ backgroundImage: `url(${locPhoto})` }} >
                                        <div className="item-img" />
                                    </div>
                                </div>
                                <div className="item-details">
                                    <div className="row">
                                        <div className="col-12 item-name">
                                            {loc.locationName ? loc.locationName
                                                : <div className="no-data-dash">
                                                    <div />
                                                </div>
                                            }
                                        </div>
                                    </div>

                                    <div className="row">
                                        <div className="col-12 item-location">
                                            <a className={loc.locationStreet1 ? "directions-link" : "no-link"} onClick={() => this.redirectToMap(loc)}>
                                                <div className="details-icon-prepend">
                                                    <div className="icon-col">
                                                        <span className="icon-address" />
                                                    </div>
                                                    <div className="details-col">
                                                        <div className="item-location__address">
                                                            {loc.distance ? <span className="item-miles">{(loc.distance).toFixed(2)} miles - </span> : ""}
                                                            {loc.locationStreet1 ?
                                                                <div className="loc-address"><span><span className="item-street">{loc.locationStreet1}</span>{loc.locationStreet2 && <span className="item-suite">, {loc.locationStreet2}</span>}</span><span className="item-city">, {loc.locationCity}</span><span className="item-state">, {loc.locationState}</span><span className="item-zip"> {loc.locationZip}</span></div>
                                                                : <div className="no-data-dash">
                                                                    <div />
                                                                </div>
                                                            }
                                                        </div>
                                                    </div>
                                                </div>
                                            </a>
                                        </div>
                                        <div className="col-12 item-phone">
                                            <a className={loc.locationPhone ? "phone-link" : "no-link"} href={loc.locationPhone ? "tel:" + (loc.locationPhone) : "#"}>
                                                <div className="details-icon-prepend">
                                                    <div className="icon-col">
                                                        <span className="icon-phone" />
                                                    </div>
                                                    <div className="details-col">
                                                        {loc.locationPhone ?
                                                            <div>{loc.locationPhone}</div>
                                                            : <div className="no-data-dash">
                                                                <div />
                                                            </div>}
                                                    </div>
                                                </div>
                                            </a>
                                        </div>
                                        <div className="col-12 item-hours">
                                            <div className="details-icon-prepend">
                                                <div className="icon-col">
                                                    <span className="icon-clock" />
                                                </div>
                                                <div className="details-col">
                                                    {loc.openNowMessage && loc.openNowMessage.indexOf('www') === -1 ?
                                                        <div>{loc.openNowMessage}</div>
                                                        : <div className="no-data-dash">
                                                            <div />
                                                        </div>}
                                                </div>
                                            </div>
                                        </div>
                                        {loc.tierCoverage &&
                                            <div className="col-12 item-tier">
                                                <div className="details-icon-prepend">
                                                    <div className="icon-col">
                                                        {loc.tierCoverage === '1' && '$'}
                                                        {loc.tierCoverage === '2' && '$$'}
                                                    </div>
                                                    <div className="details-col">
                                                        Tier {loc.tierCoverage} In-Network
                                                    </div>
                                                </div>
                                            </div>
                                        }
                                    </div>
                                    <div className="row item-perks-container--mapCard">
                                        <div className="col-12 item-perks">
                                            {
                                                (loc && loc.perks && loc.perks.indexOf('Walk-ins') > -1) &&
                                                <div className="accepts-walkins-perk"><span className="icon-accepts" />Accepts walk-ins</div>
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className={"col-12 item-perks-container--list" + (!(loc && loc.perks && loc.perks.indexOf('Walk-ins') > -1) ? ' no-perks' : '')}>
                                <div className="item-perks">
                                    <div className="row">
                                        {
                                            (loc && loc.perks && loc.perks.indexOf('Walk-ins') > -1) &&
                                            <div className="col accepts-walkins-perk"><span className="icon-accepts" />Accepts walk-ins</div>
                                        }
                                    </div>
                                </div>
                            </div>

                            {showLocationSlots && <ServiceLocationSlots loc={loc} isMammogram={window.serverData.data.enableFindCareNewSearchTerms} buttonText={this.props.buttonText} scheduleCampaignReferrer={scheduleCampaignReferrer} />}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}